import { Icon } from '@iconify/react'
import useCreateDoctor from './hooks/useCreateDoctor'
import './style.css'
import { useTranslation } from 'react-i18next'
import SpecialitiesDocs from './sections/SpecialitiesDocs'
import PersonalInfo from './sections/PersonalInfo'
import ActionBtn from '@/components/ActionBtn'

const CreateDoctor = () => {
    const {
        isLoading,
        profileImage,
        documents,
        formHandler,
        handleProfileImageChange,
        handleDocumentsChange,
        handleSubmit,
        navToDoctorReport,
    } = useCreateDoctor()


    const { i18n, t } = useTranslation()


    return (
        <div className="create-doctor-container">
            <div className="page-header">
                <button className="back-button" onClick={navToDoctorReport}>
                    <Icon icon={`mdi:arrow-${i18n.language === 'ar' ? 'right' : 'left'}`} />
                    {t('back-to-doctors')}
                </button>
                <div className="header-content">
                    <h1>{t('add-new-doctor')}</h1>
                    <p className="subtitle">{t('enter-doctor-details')}</p>
                </div>
            </div>

            <PersonalInfo formHandler={formHandler} handleProfileImageChange={handleProfileImageChange} profileImage={profileImage} />

            <SpecialitiesDocs formHandler={formHandler} handleDocumentsChange={handleDocumentsChange} documents={documents} />

            <div className="form-actions">
                <ActionBtn title={'cancel'} onApply={navToDoctorReport} disabled={isLoading} />
                <ActionBtn title={isLoading ? 'saving...' : 'add-doctor'} onApply={handleSubmit} disabled={isLoading} />
            </div>
        </div>
    )
}

export default CreateDoctor
